// extracted by mini-css-extract-plugin
export var active = "LanguageSelector-module--active--Tf6yt";
export var almostBlack = "#333";
export var almostWhite = "#f0f0f0";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var darkGrey = "#4b4d4b";
export var error = "#f66a83";
export var externalLinkIcon = "LanguageSelector-module--externalLinkIcon--SEJdJ";
export var flag = "LanguageSelector-module--flag--PB3C6";
export var formControl = "LanguageSelector-module--formControl--Tz9TH";
export var green = "#3dae2b";
export var grey = "#828382";
export var icon = "LanguageSelector-module--icon--In7st";
export var lightGreen = "#93d500";
export var lightGrey = "#aba9a9";
export var menuItem = "LanguageSelector-module--menuItem--MG8SO";
export var name = "LanguageSelector-module--name--z0O7U";
export var orange = "#fc9948";
export var paleBlue = "#64a1bb";
export var paper = "LanguageSelector-module--paper--5+ppN";
export var root = "LanguageSelector-module--root--nDfiN";
export var success = "#1ebc7b";
export var warning = "#ffeda0";
export var white = "#fff";
export var yellow = "#fbc900";